import API from 'services/TAPS_API/index';

export default function getCameralAuditForDocumentId(id) {
  return API.request({
    method: 'GET',
    url: `/notification/1151020/cameral/cameralId/${id}`,
    mapper: function (data) {
      data.cameralStates = data.cameralStates || [];
      return data;
    },
  });
}
